import { Injectable } from '@angular/core';
import { CanActivate,CanLoad, Route, UrlSegment, Router,RouterStateSnapshot,
  ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PanelAccessGuard implements CanLoad {
  constructor(private router: Router) {}

  // canLoad(route: Route, segments: UrlSegment[]): boolean {
  //   const raw = localStorage.getItem('program');
  //   const user = raw ? JSON.parse(raw) : null;

  //   if (!user) {
  //     this.router.navigateByUrl('/signin');
  //     return false;
  //   }

  //   const expectedPanel = route.path;
  //   const actualPanel = this.getAllowedPanel(user);

  //   if (expectedPanel === actualPanel) {
  //     return true;
  //   }

  //   // this.router.navigateByUrl(this.getHomeUrl(user));
  //   return false;
  // }

  // private getAllowedPanel(user: any): string {
  //   if (user.user_role == 1 || user.role_name === 'Organization' || user.profile_code === 'GNRL') {
  //     return 'hubAdmin';
  //   }
  //   if (user.role_name === 'Agent' || (user.user_role >= 12 && user.user_role <= 16)) {
  //     return 'agent';
  //   }
  //   if (user.role_name === 'Finance') {
  //     return 'finance';
  //   }
  //   if (user.role_name === 'Authorization') {
  //     return 'authorization';
  //   }
  //   if (user.role_name === 'Reporting') {
  //     return 'reports';
  //   }
  //   if (user.role_name === 'Redemption') {
  //     return 'redemption';
  //   }
  //   if (user.role_name === 'Staff') {
  //     return 'teamleader';
  //   }
  //   if (user.user_role == 9 || user.user_role == 10) {
  //     return 'operationalhead';
  //   }
  //   if (user.user_role == 11) {
  //     return 'concierge';
  //   }

  //   return 'signin';
  // }

  // private getHomeUrl(user: any): string {
  //   const panel = this.getAllowedPanel(user);

  //   switch (panel) {
  //     case 'hubAdmin':
  //       return '/hubAdmin/dashboard';
  //     case 'agent':
  //       return '/agent';
  //     case 'finance':
  //       return '/finance';
  //     case 'authorization':
  //       return '/authorization';
  //     case 'reports':
  //       return '/reports';
  //     case 'redemption':
  //       return '/redemption';
  //     case 'teamleader':
  //       return '/teamleader';
  //     case 'operationalhead':
  //       return '/operationalhead';
  //     case 'concierge':
  //       return '/concierge';
  //     default:
  //       return '/signin';
  //   }
  // }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return this.hasPanelAccess(route.path);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const expectedPanel = route.routeConfig && route.routeConfig.path ? route.routeConfig.path : '';
    return this.hasPanelAccess(expectedPanel);
  }

  private hasPanelAccess(expectedPanel: string): boolean {
    const raw = localStorage.getItem('program');
    const user = raw ? JSON.parse(raw) : null;

    if (!user) {
      this.router.navigateByUrl('/signin');
      return false;
    }

    const actualPanel = this.getAllowedPanel(user);

    if (expectedPanel === actualPanel) {
      return true;
    }

    return false;
  }

  private getAllowedPanel(user: any): string {
    if (user.user_role == 1 || user.role_name === 'Organization' || user.profile_code === 'GNRL') {
      return 'hubAdmin';
    }
    if (user.role_name === 'Agent' || (user.user_role >= 12 && user.user_role <= 16)) {
      return 'agent';
    }
    if (user.role_name === 'Finance') {
      return 'finance';
    }
    if (user.role_name === 'Authorization') {
      return 'authorization';
    }
    if (user.role_name === 'Reporting') {
      return 'reports';
    }
    if (user.role_name === 'Redemption') {
      return 'redemption';
    }
    if (user.role_name === 'Staff') {
      return 'teamleader';
    }
    if (user.user_role == 9 || user.user_role == 10) {
      return 'operationalhead';
    }
    if (user.user_role == 11) {
      return 'concierge';
    }

    return 'signin';
  }
}

